import { create } from "zustand";
import { persist } from "zustand/middleware";
import { FOTT_SERVICE_REQUEST_FORM_STORAGE_KEY } from "../constants";
import { fottServiceRequestDefaultValues, type FottServiceRequestFormData } from "../schema";

interface FottServiceRequestFormMethods {
  setField<K extends keyof FottServiceRequestFormData>(
    key: K,
    val: FottServiceRequestFormData[K],
  ): void;
  setAll(data: Partial<FottServiceRequestFormData>): void;
  resetForm(): void;
}

export interface FottServiceRequestFormState
  extends FottServiceRequestFormData,
    FottServiceRequestFormMethods {}

export const useFottServiceRequestFormStore = create<FottServiceRequestFormState>()(
  persist(
    (set) => ({
      ...fottServiceRequestDefaultValues,
      setField: (key, val) => set((state) => ({ ...state, [key]: val })),
      setAll: (data) => set((state) => ({ ...state, ...data })),
      resetForm: () => set(() => ({ ...fottServiceRequestDefaultValues })),
    }),
    { name: FOTT_SERVICE_REQUEST_FORM_STORAGE_KEY },
  ),
);
